export const SYNC_MIGRATION_SQL = `
CREATE TABLE sync_cursors (
  domain TEXT PRIMARY KEY NOT NULL,
  cursor TEXT NOT NULL,
  updated_at TEXT NOT NULL
) STRICT;

CREATE INDEX idx_sync_cursors_cursor ON sync_cursors(cursor);

CREATE TABLE outbox (
  id TEXT PRIMARY KEY NOT NULL,
  domain TEXT NOT NULL,
  payload_json TEXT NOT NULL,
  idempotency_key TEXT NOT NULL UNIQUE,
  state TEXT NOT NULL CHECK (state IN ('pending', 'inflight', 'acked', 'failed', 'conflict')),
  replay_order INTEGER NOT NULL,
  lease_expires_at TEXT,
  attempt_count INTEGER NOT NULL DEFAULT 0,
  created_at TEXT NOT NULL,
  updated_at TEXT NOT NULL
) STRICT;

CREATE INDEX idx_outbox_domain_state_replay_order
  ON outbox(domain, state, replay_order);
CREATE INDEX idx_outbox_lease_expiry
  ON outbox(state, lease_expires_at) WHERE lease_expires_at IS NOT NULL;

CREATE TABLE sync_conflicts (
  id TEXT PRIMARY KEY NOT NULL,
  domain TEXT NOT NULL,
  entity_id TEXT NOT NULL,
  state TEXT NOT NULL CHECK (state IN ('open', 'resolved')),
  base_json TEXT,
  local_json TEXT NOT NULL,
  remote_json TEXT NOT NULL,
  created_at TEXT NOT NULL,
  resolved_at TEXT
) STRICT;

CREATE INDEX idx_sync_conflicts_domain_state
  ON sync_conflicts(domain, state, created_at);
`;
//# sourceMappingURL=002_sync.sql.js.map